import Vue from 'vue'
import Main from './Dialog.vue'
import { IOption } from './type'

const DialogConstructor = Vue.extend(Main)

declare class DialogComponent extends Vue {
  show(options: IOption): void
  close(): void
  back(options?: IOption): void
}

declare module 'vue/types/vue' {
  interface Vue {
    $dialog: DialogComponent
  }
}

let instance: any

const Dialog = (globalOptions = {}) => {
  if (Vue.prototype.$isServer) return
  if (!instance) {
    instance = new DialogConstructor({
      data () {
        return {
          globalOptions
        }
      }
    })
    instance.vm = instance.$mount() // 挂载实例
    document.body.appendChild(instance.vm.$el) // 插入dom
  }
  return instance.vm
}

export default {
  install: (Vue: any, globalOptions: any) => {
    Vue.prototype.$dialog = Dialog(globalOptions)
  }
}
